// Texto exibido ao lado de uma empresa que já pertence a outro Grupo Econômico.
export const SEPARADOR_VINCULO = ' — ';

export const descricaoVinculoGrupo = (nomeGrupo: string): string =>
  `Já vinculada ao grupo ${nomeGrupo}`;
